import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Para quién es exactamente este sistema?',
  answer: 'Este sistema está diseñado tanto para facilitadores de constelaciones que buscan profesionalizar su práctica, como para terapeutas holísticos que desean integrar la mirada sistémica en sus consultas. También es ideal para personas en procesos de búsqueda personal que quieran comprender sus lealtades invisibles y encontrar su lugar en el sistema.'
}, {
  question: '¿Necesito tener conocimientos previos en Constelaciones Familiares?',
  answer: 'No es requisito ser un experto. El Sistema Profesional está estructurado para guiarte paso a paso, desde los conceptos fundamentales de los órdenes del amor hasta la aplicación de movimientos de solución complejos. Te brindamos la infraestructura operativa que normalmente no se profundiza en las formaciones teóricas.'
}, {
  question: '¿Cómo recibo el material y por cuánto tiempo tengo acceso?',
  answer: 'El acceso es inmediato. Una vez realizado el pago, recibirás un correo electrónico con tus credenciales de acceso. El acceso es vitalicio, incluyendo todas las actualizaciones futuras del kit. Puedes descargar los genogramas, guías y protocolos para consultarlos a tu propio ritmo.'
}, {
  question: '¿El material es útil para sesiones online?',
  answer: '¡Totalmente! El sistema incluye herramientas digitales diseñadas específicamente para la virtualidad, como plantillas de genogramas editables en Canva y protocolos de visualización sistémica que funcionan perfectamente a través de una pantalla. Dejá de improvisar y dale un marco profesional a tu consulta a distancia.'
}, {
  question: '¿Qué diferencia este kit de otros cursos de Constelaciones?',
  answer: 'La mayoría de las formaciones se centran solo en la teoría de Bert Hellinger. Nosotros nos enfocamos en la metodología práctica y operativa. Aprendés a realizar diagnósticos precisos, a identificar implicancias sistémicas rápidamente y, sobre todo, a aplicar protocolos de protección para no cargar con destinos ajenos.'
}, {
  question: '¿Es seguro el pago y qué pasa si no es lo que esperaba?',
  answer: 'Tu pago está protegido por tecnología de encriptación de grado bancario. Además, confiamos tanto en la calidad de este arsenal sistémico que contás con nuestra garantía de satisfacción. Si sentís que el material no eleva tu práctica profesional o personal, estamos aquí para respaldarte.'
}, {
  question: '¿Puedo aplicarlo en sesiones individuales o solo grupales?',
  answer: 'El sistema está adaptado para ambas modalidades. Incluye guiones específicos para movimientos de solución en consulta individual y dinámicas para el trabajo con representantes en talleres grupales. Es una herramienta versátil que se ajusta a tu forma de trabajar.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-24 bg-white pt-[30px] pb-[30px]" data-id="element-137">
      <div className="max-w-3xl mx-auto px-4" data-id="element-138">
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-blue-600 font-black uppercase tracking-[0.3em] mb-4 text-xs" data-id="element-140">
            DESPEJA TUS DUDAS
          </h2>
          <h3 className="text-[#d97706] font-['Dancing_Script',_cursive] text-[36px] md:text-6xl" data-id="element-141">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="space-y-4" data-id="element-142">
          {faqs.map((faq, index) => <div key={index} className="border border-blue-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-blue-200" data-id="element-143">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-blue-50/30 hover:bg-blue-50 transition-colors" data-id="element-144">
                <span className="font-bold text-blue-950 pr-8 leading-tight" data-id="element-145">
                  {faq.question}
                </span>
                <div className="shrink-0 text-blue-600" data-id="element-146">
                  {activeIndex === index ? <Minus size={20} data-id="element-147" /> : <Plus size={20} data-id="element-148" />}
                </div>
              </button>

              <AnimatePresence data-id="element-149">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-150">
                    <div className="p-6 pt-0 text-blue-800/80 leading-relaxed bg-blue-50/30" data-id="element-151">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-20 text-center border-t border-blue-100 pt-12" data-id="element-152">
          <div className="inline-flex items-center gap-2 text-blue-400 mb-6" data-id="element-153">
            <HelpCircle size={20} data-id="element-154" />
            <span className="text-sm font-medium uppercase tracking-widest" data-id="element-155">
              Honrar el Origen
            </span>
          </div>
          <p className="text-blue-900 font-serif italic text-xl max-w-lg mx-auto" data-id="element-156">
            "Cuando cada uno ocupa su lugar en el sistema, el amor fluye y la
            vida se vuelve posible. Honrar a los que vinieron antes es la llave
            de tu propia fuerza."
          </p>
        </div>
      </div>
    </section>;
}